import { useThirdPartyOrderQuery } from "@gql/sites-api/graphql";
import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";

export const useRoutedThirdPartyOrderQuery = (thirdPartyOrderId: string) => {
  const { data, loading, error } = useThirdPartyOrderQuery({
    variables: { id: thirdPartyOrderId },
    skip: !thirdPartyOrderId,
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
  });

  return { order: data?.thirdPartyOrder, loading, error };
};
